import getConfig from "next/config";

// We set default values here because without them getConfig will be undefined in the test environment
// (i.e. Jest). This happens because the Next.js server is not running in that environment.
// See: https://github.com/vercel/next.js/issues/4024#issuecomment-377837421
// and its parent issue for more information.
const { serverRuntimeConfig = {}, publicRuntimeConfig = {} } =
  getConfig() || {};

export const API_BASE = serverRuntimeConfig.apiBase;
export const SUBSCRIPTION_UTILS_URL = publicRuntimeConfig.subscriptionUtilsUrl;
export const INTELLIGENCE_DB_UTILS_BASE_URL =
  serverRuntimeConfig.intelligenceDbUtilsUrl;
export const DATO_ENV = serverRuntimeConfig.datoEnv;

export const DATOCMS_BASE = publicRuntimeConfig.datoCmsBase;
export const MIXPANEL_TOKEN = publicRuntimeConfig.mixpanelToken;
export const MIXPANEL_RECORD_SESSIONS_PERCENT =
  publicRuntimeConfig.mixpanelRecordSessionsPercent;

export const CONTENT_API_URL = API_BASE + "/content";

export const GOOGLE_TAG_MANAGER_ID = "GTM-KH4T3PH";
export const GOOGLE_ANALYTICS_ID = "UA-127308923-1";
export const COOKIEBOT_ID = "33e59a16-c6e6-406b-8161-7e6b9693bc2e";

export const SIFTED_WP_SITE = "https://sifted.eu";

export const INTELLIGENCE_UNIT_GENERAL_INTEREST_MAILCHIMP =
  "https://sifted.us19.list-manage.com/subscribe/post?u=f728a14fdc520a63f329940f5&id=595e55ffc1";

export const DATOCMS_READ_ONLY_API_TOKEN =
  serverRuntimeConfig.datoCmsReadOnlyApiToken;
export const DATOCMS_READ_ONLY_API_TOKEN_HOMEPAGE =
  serverRuntimeConfig.datoCmsReadOnlyApiTokenHomepage;
export const DATOCMS_READ_ONLY_API_TOKEN_BRIEFINGS =
  serverRuntimeConfig.datoCmsReadOnlyApiTokenBriefings;
export const DATOCMS_READ_ONLY_API_TOKEN_EVENTS =
  serverRuntimeConfig.datoCmsReadOnlyApiTokenEvents;
export const DATOCMS_READ_ONLY_API_TOKEN_REPORTS =
  serverRuntimeConfig.datoCmsReadOnlyApiTokenReports;
export const DATOCMS_READ_ONLY_API_TOKEN_RANKINGS =
  serverRuntimeConfig.datoCmsReadOnlyApiTokenRankings;
export const DATOCMS_READ_ONLY_API_TOKEN_SITEWIDE_OPTIONS =
  serverRuntimeConfig.datoCmsReadOnlyApiTokenSitewideOptions;
export const DATOCMS_READ_ONLY_API_TOKEN_MEMBERS =
  serverRuntimeConfig.datoCmsReadOnlyApiTokenMembers;
export const DATOCMS_READ_ONLY_API_TOKEN_CONTENT =
  serverRuntimeConfig.datoCmsReadOnlyApiTokenContent;
export const DATOCMS_READ_ONLY_API_TOKEN_COMPANY =
  serverRuntimeConfig.datoCmsReadOnlyApiTokenCompany;

export const DATADOG_API_TOKEN = publicRuntimeConfig.datadogAPIToken;
export const DATADOG_APP_ID = publicRuntimeConfig.datadogAppID;
export const DATADOG_ENVIRONMENT = publicRuntimeConfig.datadogEnvironment;
export const DATADOG_API_KEY = serverRuntimeConfig.datadogAPIKey;

export const MENU_ITEMS_API_URL = API_BASE + "/structure/menus";

export const FUTURE_PROOF_PAGE_API_URL = (() => {
  const STAGING_PAGE_ID = "21930";
  const PROD_PAGE_ID = "34411";

  const pageId =
    process.env.STAGING === "true" ? STAGING_PAGE_ID : PROD_PAGE_ID;

  return CONTENT_API_URL + "/page/" + pageId;
})();

export const ARTICLE_API_URL = CONTENT_API_URL + "/article/";
export const RELATED_ARTICLES_API_URL = CONTENT_API_URL + "/relatedArticles/";
export const ARTICLE_FILTER_LIST_API_URL = CONTENT_API_URL + "/articles";
export const DATO_PROXY_API = API_BASE + "/dato";

export const IS_CI = publicRuntimeConfig.isCI;

export const SINGLE_SEAT = "Single-Seat";

export const NUDGE_PRO_TRIAL_LAST_DAY =
  publicRuntimeConfig.nudgeProTrialLastDay;
export const NUDGE_PRO_TRIAL_DAY_3 = publicRuntimeConfig.nudgeProTrialDay3;

export const ZEPHR_CDN_URL = serverRuntimeConfig.ZEPHR_CDN_URL;
export const VERIFIED_CRAWLER_SECRET =
  serverRuntimeConfig.verifiedCrawlerSecret;

// JISC OAuth Configuration
export const JISC_CLIENT_ID = serverRuntimeConfig.jiscClientId;
export const JISC_CLIENT_SECRET = serverRuntimeConfig.jiscClientSecret;
export const JISC_REDIRECT_URI = serverRuntimeConfig.jiscRedirectUri;
export const JISC_OAUTH_ENABLED = publicRuntimeConfig.jiscOAuthEnabled;
export const JISC_SAMESITE_ORIGIN = serverRuntimeConfig.jiscSamesiteOrigin;
export const JISC_LOGIN_EXPIRY_DURATION =
  serverRuntimeConfig.jiscLoginExpiryDuration;
export const JISC_UNIVERSITY_ENTITY_ID =
  serverRuntimeConfig.jiscUniversityEntityId;
export const JISC_DEFAULT_DISCOVERY_URL =
  serverRuntimeConfig.jiscDefaultDiscoveryUrl;
export const JISC_VERIFY_URL = serverRuntimeConfig.jiscVerifyUrl;
